'use strict';

const { h } = require('phy');

function LayoutServiceLinks({ layoutServiceMenu }) {
  const { links = [] } = layoutServiceMenu || {};

  if (!links || !links.length) {
    return null;
  }

  const linksElement = links.map(link =>
    h('a', { href: link.link }, link.text)
  );

  return h('div', [
    h(
      '.subnav-categories',
      {
        style: { display: 'none' },
      },
      linksElement
    ),
    h('noscript', h('.subnav-categories', linksElement)),
  ]);
}

module.exports = LayoutServiceLinks;
